module.exports = __webpack_public_path__ + "static/media/Summary.6db79e73.png";